<template>
  <v-container class="register pa-0" fluid>
    <HkiaraceBannerFrame :src="require('@/assets/canteen_home.png')"
                         :label="$t('register.title')"
                         is-always-large
                         is-snap-content>
      <div class="form-div">
        <v-row v-if="step !== 4 || (submittedSasv && submittedSasv.validated_at)">
          <v-col class="form-title title-font text-center">
            {{ stepTitles[step] }}
          </v-col>
        </v-row>
        <v-window v-model="step"
                  touchless>
          <v-window-item>
            <v-container>
              <v-form ref="stepOneForm">
                <v-row>
                  <v-col>
                    <div v-html="tnc"
                         class="tnc-textarea">

                    </div>
                    <!--                    <v-textarea rows="10"-->
                    <!--                                no-resize-->
                    <!--                                background-color="#E3DFDA"-->
                    <!--                                :value="tnc"-->
                    <!--                                hide-details="auto"></v-textarea>-->
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-checkbox light
                                :label="$t('register.agree_tnc')"
                                :rules="[value => !!value || $t('register.require_tnc')]"
                                hide-details="auto">
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center">
                    <v-btn dark
                           color="primary"
                           rounded
                           x-large
                           @click="$refs.stepOneForm.validate() && nextStep()">
                      {{ $t('next') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-window-item>
          <v-window-item>
            <v-container>
              <v-form ref="stepTwoForm">
                <v-row>
                  <v-col>
                    <v-text-field outlined
                                  :label="$t('register.surname')"
                                  placeholder="CHAN"
                                  persistent-placeholder
                                  v-model="surname"
                                  :rules="nameRules"
                                  hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field outlined
                                  :label="$t('register.given_name')"
                                  placeholder="TAI MAN"
                                  persistent-placeholder
                                  v-model="givenName"
                                  :rules="nameRules"
                                  hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field outlined
                                  :label="$t('register.octopus_no')"
                                  placeholder="123456789"
                                  persistent-placeholder
                                  v-model="octopusNo"
                                  v-mask="'########?#?#'"
                                  :rules="octopusNoRules"
                                  :hint="$t('register.octopus_no_hint')"
                                  persistent-hint
                                  hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center">
                    <v-btn dark
                           color="primary"
                           rounded
                           x-large
                           @click="$refs.stepTwoForm.validate() && checkSasv()">
                      {{ $t('next') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-window-item>
          <v-window-item>
            <v-container>
              <v-form ref="stepThreeForm">
                <v-row>
                  <v-col>
                    <v-text-field readonly
                                  :label="$t('register.surname')"
                                  placeholder="CHAN"
                                  persistent-placeholder
                                  v-model="surname"
                                  hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field readonly
                                  :label="$t('register.given_name')"
                                  placeholder="TAI MAN"
                                  persistent-placeholder
                                  v-model="givenName"
                                  hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field readonly
                                  :label="$t('register.octopus_no')"
                                  placeholder="123456789"
                                  persistent-placeholder
                                  v-model="octopusNo"
                                  hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-autocomplete outlined
                                    :label="$t('register.company')"
                                    :placeholder="$t('register.company')"
                                    :items="companyOptions"
                                    v-model="selectedCompanyId"
                                    :rules="companyRules"
                                    clearable
                                    :disabled="showOtherCompanyInput"
                                    hide-details="auto">
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-checkbox light
                                :label="$t('register.cannot_find_company')"
                                v-model="showOtherCompanyInput"
                                hide-details="auto">
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field outlined
                                  :label="$t('register.other_company_name')"
                                  :placeholder="$t('register.other_company_name')"
                                  v-model="otherCompanyName"
                                  :rules="otherCompanyNameRules"
                                  v-if="showOtherCompanyInput"
                                  hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center">
                    <v-btn dark
                           color="primary"
                           rounded
                           x-large
                           @click="step = 1">
                      {{ $t('back') }}
                    </v-btn>
                  </v-col>
                  <v-col class="text-center">
                    <v-btn dark
                           color="primary"
                           rounded
                           x-large
                           @click="$refs.stepThreeForm.validate() && nextStep()">
                      {{ $t('next') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-window-item>
          <v-window-item>
            <v-container>
              <v-form ref="stepFourForm">
                <v-row>
                  <v-col>
                    <v-radio-group v-model="idType"
                                   column
                                   :rules="requiredRules">
                      <v-radio value="AIRPORT_OCTOPUS" :label="$t('id_type.AIRPORT_OCTOPUS')"></v-radio>
<!--                      <v-radio value="PERSONAL_OCTOPUS_AND_STAFF_CARD"-->
<!--                               :label="$t('id_type.PERSONAL_OCTOPUS_AND_STAFF_CARD')"></v-radio>-->
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-input :rules="requiredRules"
                             v-model="octopusFront">
                      <v-container fluid class="flex-column pa-0">
                        <legend class="v-label theme--light">{{ $t('register.octopus_front') }}</legend>
                        <PhotoPreviewInput v-model="octopusFront"
                                           div-class="octopus-front"
                                           file-name="octopus-front"></PhotoPreviewInput>
                      </v-container>
                    </v-input>
                  </v-col>
                  <v-col>
                    <v-input :rules="requiredRules"
                             v-model="octopusBack">
                      <v-container fluid class="flex-column pa-0">
                        <legend class="v-label theme--light">{{ $t('register.octopus_back') }}</legend>
                        <PhotoPreviewInput v-model="octopusBack"
                                           div-class="octopus-back"
                                           file-name="octopus-back"></PhotoPreviewInput>
                      </v-container>
                    </v-input>
                  </v-col>
                </v-row>
                <v-row v-if="idType === 'PERSONAL_OCTOPUS_AND_STAFF_CARD'">
                  <v-col>
                    <v-input :rules="requiredRules"
                             v-model="staffCardFront">
                      <v-container fluid class="flex-column pa-0">
                        <legend class="v-label theme--light">{{ $t('register.staff_card_front') }}</legend>
                        <PhotoPreviewInput v-model="staffCardFront"
                                           div-class="staff-card-front"
                                           file-name="staff-card-front"></PhotoPreviewInput>
                      </v-container>
                    </v-input>
                  </v-col>
                  <v-col>
                    <v-input :rules="requiredRules"
                             v-model="staffCardBack">
                      <v-container fluid class="flex-column pa-0">
                        <legend class="v-label theme--light">{{ $t('register.staff_card_back') }}</legend>
                        <PhotoPreviewInput v-model="staffCardBack"
                                           div-class="staff-card-back"
                                           file-name="staff-card-back"></PhotoPreviewInput>
                      </v-container>
                    </v-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-input :rules="requiredRules"
                             v-model="gCaptchaResponse">
                      <VueRecaptcha ref="recaptcha"
                                    sitekey="6LcWt7IUAAAAABME-H9-LYoOsynOYo34NHU7ur2y"
                                    :loadRecaptchaScript="false"
                                    @verify="recaptchaVerified"
                                    @expired="gCaptchaResponse = null"
                                    size="150px"></VueRecaptcha>
                    </v-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center">
                    <v-btn dark
                           color="primary"
                           rounded
                           x-large
                           @click="step = 2">
                      {{ $t('back') }}
                    </v-btn>
                  </v-col>
                  <v-col class="text-center">
                    <v-btn dark
                           color="primary"
                           rounded
                           x-large
                           @click="$refs.stepFourForm.validate() && submit()">
                      {{ $t('submit') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-window-item>
          <v-window-item>
            <SasvStatus :sasv="submittedSasv"
                        v-if="submittedSasv && submittedSasv.status !== 'APPROVED'"
                        max-width="400px"></SasvStatus>

            <v-row v-if="submittedSasv && submittedSasv.status === 'REJECTED'"
                   class="text-center mt-4">
              <v-col>
                <v-btn color="primary"
                       @click="resubmit">{{ $t('resubmit') }}
                </v-btn>
              </v-col>
            </v-row>

            <v-container v-if="submittedSasv && submittedSasv.status === 'APPROVED'">
              <v-row>
                <v-col class="title-font text-center">
                  {{ $t('register.registration_complete_details') }}
                </v-col>
              </v-row>
            </v-container>
          </v-window-item>
        </v-window>
      </div>

<!--      <v-row class="register-complete"-->
<!--             v-if="submittedSasv && submittedSasv.status === 'APPROVED'"-->
<!--             :no-gutters="pageWidth > 600">-->
<!--        <v-col class="hkiarace-col" cols="12" sm="6">-->
<!--          <div class="hkiarace-banner"-->
<!--               :style="'height:' + (pageWidth>1800?(pageWidth/28):pageWidth>1600?(pageWidth/26):pageWidth>1400?(pageWidth/24):pageWidth>1200?(pageWidth/22):(pageWidth/61 + 30)) +'vh'"></div>-->
<!--          <div class="hkiarace-description-wrapper">-->
<!--            <v-container fluid class="hkiarace-description-content">-->
<!--              <v-row>-->
<!--                <v-col class="title hkiarace-title">-->
<!--                  {{ $t('register.hkiarace_upsell') }}-->
<!--                </v-col>-->
<!--              </v-row>-->
<!--              <v-row>-->
<!--                <v-col>-->
<!--                  <a :href="hkiaraceUrl" target="_blank">-->
<!--                    <v-btn rounded-->
<!--                           color="primary">{{ $t('register.hkiarace_btn') }}-->
<!--                    </v-btn>-->
<!--                  </a>-->
<!--                </v-col>-->
<!--              </v-row>-->
<!--              <v-row class="hkiarace-subtitle">-->
<!--                <v-col>-->
<!--                  {{ $t('register.hkiarace_btn_subtitle') }}-->
<!--                </v-col>-->
<!--              </v-row>-->
<!--            </v-container>-->
<!--          </div>-->
<!--        </v-col>-->
<!--        <v-col class="aca-col" cols="12" sm="6">-->
<!--          <div class="aca-banner"-->
<!--               :style="'height:' + (pageWidth>1800?(pageWidth/28):pageWidth>1600?(pageWidth/26):pageWidth>1400?(pageWidth/24):pageWidth>1200?(pageWidth/22):(pageWidth/61 + 30)) +'vh'">-->
<!--            <div class="aca-hand"></div>-->
<!--          </div>-->

<!--          <div class="aca-description-wrapper">-->
<!--            <v-container fluid class="aca-description-content">-->
<!--              <v-row>-->
<!--                <v-col class="title aca-title">-->
<!--                  {{ $t('register.aca') }}-->
<!--                </v-col>-->
<!--              </v-row>-->
<!--              <v-row class="aca-subtitle">-->
<!--                <v-col>-->
<!--                  {{ $t('register.aca_subtitle') }}-->
<!--                </v-col>-->
<!--              </v-row>-->
<!--              <v-row no-gutters>-->
<!--                <v-col cols="12">-->
<!--                  <a href="https://play.google.com/store/apps/details?id=com.hkgcommunity&hl=zh_HK&gl=US"-->
<!--                     target="_blank">-->
<!--                    <v-img :src="require('@/assets/google_play.png')"-->
<!--                           contain-->
<!--                           width="150px"-->
<!--                           class="my-4"></v-img>-->
<!--                  </a>-->
<!--                </v-col>-->
<!--                <v-col cols="12">-->
<!--                  <a :href="$t('register.appstore_link')" target="_blank">-->
<!--                    <v-img :src="require('@/assets/app_store.png')"-->
<!--                           contain-->
<!--                           width="150px"></v-img>-->
<!--                  </a>-->
<!--                </v-col>-->
<!--              </v-row>-->

<!--            </v-container>-->
<!--          </div>-->
<!--        </v-col>-->
<!--      </v-row>-->

    </HkiaraceBannerFrame>
  </v-container>
</template>

<script>
import {computed, onMounted, ref} from '@vue/composition-api';
import HkiaraceBannerFrame from "@/components/HkiaraceBannerFrame";
import {ACTION_TYPES} from "@/store/types";
import VueRecaptcha from 'vue-recaptcha'
import PhotoPreviewInput from "@/components/PhotoPreviewInput";
import SasvStatus from "@/components/SasvStatus";
import _ from 'lodash';

export default {
  name: 'Register',
  components: {SasvStatus, PhotoPreviewInput, HkiaraceBannerFrame, VueRecaptcha},
  setup(props, {root}) {
    const requiredRules = ref([
      value => !!value || root.$t('register.enter_required_field'),
    ]);

    const step = ref(0);
    const stepTitles = computed(() => [
      root.$t('register.tnc'),
      root.$t('register.step_2'),
      root.$t('register.step_3'),
      root.$t('register.step_4'),
      (submittedSasv.value && submittedSasv.status === 'APPROVED') ? root.$t('register.registration_complete') : '',
    ])
    const nextStep = function () {
      step.value = step.value + 1;

      if (step.value === 3) {
        loadRecaptcha();
      }
    }
    const tnc = ref('')
    const getTnc = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'sasv/tnc/',
        params: {},
      });
      tnc.value = response.body.content;
    };
    onMounted(async () => {
      await getTnc();
    })

    const surname = ref(null);
    const givenName = ref(null);
    const nameRules = ref([
      value => !!value || root.$t('register.enter_required_field'),
      value => !!/^[a-zA-Z ]*$/g.test(value) || root.$t('register.only_input_english_characters'),
    ]);
    const octopusNo = ref(null);
    const octopusNoRules = ref([
      value => !!value || root.$t('register.enter_required_field'),
      value => !!/^[0-9]{8,10}$/g.test(value) || root.$t('register.incorrect_octopus_no'),
    ]);
    const checkSasv = async function () {
      try {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'sasv/status/',
          params: {
            surname: surname.value,
            given_name: givenName.value,
            octopus_no: octopusNo.value,
          },
        });

        if (response.body.sasv) {
          let sasv = response.body.sasv;
          if (sasv.status !== 'NOT_SUBMITTED' && sasv.status !== 'REJECTED') { // Submitted
            submittedSasv.value = sasv;
            step.value = 4;
            return
          } else { // Resume Registration
            octopusNo.value = sasv.octopus_no;
            selectedCompanyId.value = sasv.company ? sasv.company.id : '';
            showOtherCompanyInput.value = !!sasv.other_company_name;
            otherCompanyName.value = sasv.other_company_name;
            idType.value = sasv.id_type;
          }
        }

        await getCompanies();
        step.value = 2;
      } catch (response) {
        root.$tryHandleError(response);
      }
    };

    const selectedCompanyId = ref('');
    const companyRules = computed(() => [
      value => (showOtherCompanyInput.value || !!value) || root.$t('register.select_company'),
    ]);
    const showOtherCompanyInput = ref(false);
    const otherCompanyNameRules = computed(() => [
      value => value.length > 0 || root.$t('register.enter_company_name'),
    ]);
    const otherCompanyName = ref('');
    const companies = ref([]);
    const getCompanies = async function () {
      try {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'hkiarace/company/',
          params: {page_size: -1},
        });

        companies.value = response.body.companies;
      } catch (response) {
        root.$tryHandleError(response);
      }
    };
    const companyOptions = computed(() => {
      return _.sortBy(companies.value, 'name_en').map(c => {
        return {text: c.name_en + ' - ' + c.name_zh, value: c.id}
      });
    });

    const idType = ref('AIRPORT_OCTOPUS');
    const octopusFront = ref(null);
    const octopusBack = ref(null);
    const staffCardFront = ref(null);
    const staffCardBack = ref(null);

    const loadRecaptcha = function () {
      const url = `https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=${root.$i18n.locale === 'en' ? 'en' : 'zh-TW'}`;
      const $el = document.createElement('script');
      $el.src = url;
      $el.async = true;
      document.head.appendChild($el)
    };
    const recaptcha = ref(null);
    const gCaptchaResponse = ref(null);
    const recaptchaVerified = function (response) {
      gCaptchaResponse.value = response;
    };

    const submit = async function () {
      try {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'sasv/init/',
          params: {
            g_captcha_response: gCaptchaResponse.value,

            surname: surname.value,
            given_name: givenName.value,
            octopus_no: octopusNo.value,
            company_id: showOtherCompanyInput.value ? null : selectedCompanyId.value,
            other_company_name: otherCompanyName.value,
            id_type: idType.value,
            octopus_front: await root.$convertFileToBase64(octopusFront.value),
            octopus_back: await root.$convertFileToBase64(octopusBack.value),
            staff_card_front: idType.value === 'PERSONAL_OCTOPUS_AND_STAFF_CARD' ? await root.$convertFileToBase64(staffCardFront.value) : null,
            staff_card_back: idType.value === 'PERSONAL_OCTOPUS_AND_STAFF_CARD' ? await root.$convertFileToBase64(staffCardBack.value) : null,
          }
        })

        if (response.body.ocr_fail) {
          octopusFront.value = null;
          octopusBack.value = null;
          staffCardFront.value = null;
          staffCardBack.value = null;
          root.$showAlertMessage(root.$t('register.ocr_fail_msg'));
        } else {
          submittedSasv.value = response.body.sasv;
          step.value = 4;
        }
      } catch (response) {
        root.$tryHandleError(response);
      } finally {
        gCaptchaResponse.value = null;
        recaptcha.value.reset();
      }
    }
    const resubmit = function () {
      surname.value = null;
      givenName.value = null;
      octopusNo.value = null;
      selectedCompanyId.value = null;
      showOtherCompanyInput.value = false;
      otherCompanyName.value = '';
      step.value = 1;
    };

    const submittedSasv = ref(null);

    const pageWidth = computed(() => root.$vuetify.breakpoint.width);

    const hkiaraceUrl = computed(() => {
      if (submittedSasv.value) {
        return `https://hkiarace-uat.teamnoteapp.com/#/register?p=${encodeURIComponent(btoa(JSON.stringify({
          octopusNo: submittedSasv.value.octopus_no,
          surname: submittedSasv.value.surname,
          givenName: submittedSasv.value.given_name,
          company_id: submittedSasv.value.company.id,
        })))}`
      }

      return '';
    })
    const jumpToHkiarace = function () {

    }

    return {
      requiredRules,

      step,
      stepTitles,
      nextStep,
      tnc,

      surname,
      givenName,
      nameRules,
      octopusNo,
      octopusNoRules,
      checkSasv,

      selectedCompanyId,
      companyRules,
      showOtherCompanyInput,
      otherCompanyName,
      otherCompanyNameRules,
      companyOptions,

      idType,
      octopusFront,
      octopusBack,
      staffCardFront,
      staffCardBack,

      recaptcha,
      recaptchaVerified,
      gCaptchaResponse,

      submit,
      resubmit,

      submittedSasv,

      pageWidth,

      hkiaraceUrl,
      jumpToHkiarace,
    }
  }
}
</script>

<style lang="less">
.register {
  font-weight: 400;
  position: relative;

  .top-banner {
    background-image: url('../assets/acc.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    .banner-slide {
      width: 100%;
      padding-top: 22.47544204%;

      .registration-label {
        color: white;
        font-size: 2.5rem;
        position: absolute;

        top: 3rem;
        width: 100%;
        left: 0;

        line-height: 1.2;
      }
    }

    // override library class
    .carousel-item {
      margin-bottom: 10%;
    }

    .carousel-indicators {
      bottom: 100px;
      justify-content: flex-start;
      margin: 0;

      li {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin: 0 5px;
      }
    }
  }

  .tnc-textarea {
    background-color: #E3DFDA;
    padding: 8px;
    height: 240px;
    overflow: auto;
  }

  .form-div {

    padding: 16px 10% 24px 10%;
    background-color: white;

    .form-title {
      font-size: 1.5rem;
      padding-top: 32px;
      padding-bottom: 16px;
      padding-left: 12px;
    }

    .v-input {
      border-radius: 0;
    }

    .v-radio {
      .v-label {
        margin-bottom: 0rem;
      }
    }

    .v-text-field__slot {
      .v-label {
        //background-color: white;
        padding-left: 4px;
        padding-right: 4px;
      }
    }

    .v-text-field > .v-input__control > .v-input__slot:before {
      display: none;
    }

    .v-text-field > .v-input__control > .v-input__slot:after {
      display: none;
    }
  }

  .form-background {
    height: 110rem;
    background-color: rgb(239, 239, 239);
  }

  .photo-preview-input-div {
    &::before {
      content: "";
      opacity: 0.15;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      position: absolute;
    }

    &.staff-card-front::before {
      background: url('../assets/staff_card_front.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    &.octopus-front::before {
      background: url('../assets/octopus-front.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    &.staff-card-back::before {
      background: url('../assets/staff_card_back.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    &.octopus-back::before {
      background: url('../assets/octopus-back.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  .register-complete-detail {
    color: #998065;
    font-weight: bold;
  }
}

.register-complete {
  .hkiarace-col {
    position: relative;
  }

  .hkiarace-banner {
    background-image: url('../assets/happy_photo.png');
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;

    width: 100%;
    // padding-top: 48%;
    height: 20vh;
    overflow: hidden;
  }

  .hkiarace-description-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;

    .hkiarace-description-content {
      flex: 0 0 auto;
      width: 100% !important;
      position: relative;
      background-color: rgb(220, 216, 210);

      .hkiarace-title {
        color: var(--v-secondary-darken4);
      }

      .hkiarace-subtitle {
        color: var(--v-primary-base);
        font-size: 0.8rem;
      }
    }

    @media only screen and (min-width: 600px) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100% !important;
      height: 50%;
      display: flex;
      align-items: start;

      .hkiarace-description-content {
        background-color: rgba(255, 255, 255, 0.85);
        width: 100%;
        padding: 10% 5% 10% 10%;
        //padding: 32px;


      }
    }
  }

  .aca-col {
    position: relative;
  }

  .aca-banner {
    position: relative;
    background-color: #f7f7f7;

    width: 100%;
    // padding-top: 48%;
    overflow: hidden;
  }

  .aca-hand {
    background-image: url('../assets/hand.png');
    background-size: contain;
    background-position: bottom;
    background-repeat: no-repeat;

    position: absolute;
    bottom: 0;
    right: 0;
    width: 80%;
    height: 100%;
  }

  .aca-description-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 60% !important;
    height: 100%;
    display: flex;
    align-items: start;
    justify-content: center;
    color: white;
    font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;

    .aca-description-content {
      background-color: transparent;
      width: 100%;
      padding: 10% 5% 10% 10%;
      flex: 0 0 auto;
      position: relative;

      .aca-subtitle {
        color: var(--v-secondary-darken4);
        font-size: 0.8rem;
      }

      .aca-title {
        color: var(--v-secondary-darken4);
      }
    }
  }
}

.text-red {
  color: red;
}

@media only screen and (min-width: 600px) {
  .register .top-banner .banner-slide .registration-label {
    top: 8rem !important;
  }

  .form-div {
    top: calc(20% - 5rem) !important;
  }

  .form-background {
    height: 110rem !important;
  }
}

@media only screen and (min-width: 820px) {
  .form-div {
    top: calc(20% - 10rem) !important;;
  }

  .form-background {
    height: 100rem !important;
  }
}

@media only screen and (min-width: 960px) {
  .form-div {
    top: calc(20%) !important;;
  }

  .form-background {
    height: 50rem !important;
  }
}

@media only screen and (min-width: 1248px) {
  .form-div {
    top: calc(20% + 5rem) !important;
  }

  .form-background {
    height: 40rem !important;
  }
}

</style>
